export default class ViewVotesItem {
    constructor(id, category, categoryOrder, refNum, refNum2, docNum, docNumStr, title, type, status, docNumBranch1 = 0, docuNumBranch2 = 0, bindNum = null, page = null) {
        this.toJson = () => {
            return {
                id: this.id,
                cat: this.category,
                catOrder: this.categoryOrder,
                refNum: this.refNum,
                refNum2: this.refNum2,
                docNumStr: this.docNumStr,
                docNum: this.docNum,
                docNumBranch1: this.docNumBranch1,
                docNumBranch2: this.docNumBranch2,
                title: this.title,
                status: this.status,
                type: this.type,
                bindNum: this.bindNum,
                page: this.page
            };
        };
        this.id = id;
        this.category = category;
        this.categoryOrder = categoryOrder;
        this.refNum = refNum;
        this.refNum2 = refNum2 ? refNum2 : refNum;
        this.docNum = docNum;
        this.docNumBranch1 = docNumBranch1;
        this.docNumBranch2 = docuNumBranch2;
        this.docNumStr = docNumStr;
        this.title = title;
        this.type = type;
        this.status = status;
        this.bindNum = bindNum;
        this.page = page;
    }
}
